// NOTE: (TomLuce) There is a react-plyr npm module but it bugged out and wouldnt work
import * as Plyr from 'plyr';
import * as React from 'react';
import { IWindowGlobals } from '../../../javascript/application/IWindowGlobals';
import { useCompanySettings } from '../../../javascript/application/useCompanySettings';

interface IProps {
  provider: 'vimeo' | 'youtube';
  videoId: string;
}

// Finds a cookie by name
//
function getCookie(name: string) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

export default function video(props: IProps) {
  const { provider, videoId } = props;
  const plyrRef: React.RefObject<HTMLDivElement> = React.createRef();
  const [consentGiven, setConsentGiven] = React.useState<boolean>(false);

  const { isYoutubeCookieManagementEnabled } = useCompanySettings();

  // Load Plyr after consent
  React.useEffect(() => {
    function handleConsent() {
      setConsentGiven(true); // Trigger re-render if needed
    }

    // Gets the CC cookie (if it exists)
    //
    const cookieConsentCookie = getCookie('cc_cookie');
    const decodedCookieConsentCookie = JSON.parse(decodeURIComponent(cookieConsentCookie || '{}'));

    // Check if the user has given consent for analytics cookies
    //
    const analyticsConsent = decodedCookieConsentCookie?.categories?.includes('analytics');

    // Listen for your custom consent event
    document.addEventListener('cookieconsent-analytics', handleConsent);

    // If user already accepted cookies
    //
    if (analyticsConsent || !isYoutubeCookieManagementEnabled) {
      handleConsent();
    }

    return () => {
      document.removeEventListener('cookieconsent-analytics', handleConsent);
    };
  }, []);

  // Initialize Plyr once video is allowed
  React.useEffect(() => {
    if (!consentGiven || !plyrRef.current) return;

    const plyr = new Plyr(plyrRef.current, {
      clickToPlay: true,
      controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
      youtube: {
        noCookie: (window as unknown as IWindowGlobals)?.essentialCookiesOnly ?? true,
      },
    });

    plyr.on('ready', (event) => {
      const player = event.detail.plyr;
      player.toggleControls(false);
    });

    plyr.on('ended', (event) => {
      const player = event.detail.plyr;
      player.stop();
    });

    return () => {
      plyr.destroy();
    };
  }, [consentGiven, plyrRef]);

  if (!consentGiven) {
    return (
      <div className="video-consent-placeholder">
        <img
          src="https://res.cloudinary.com/pinpointhq/image/upload/v1750621390/uywki7mkmnca4hgietyw.png"
          alt="Video placeholder"
        />
      </div>
    );
  }

  return <div ref={plyrRef} data-plyr-provider={provider} data-plyr-embed-id={videoId} />;
}
